import React from 'react'
import { Flex, Label, Input, Button, Table, useDebounce } from '@fareye/ui'
import {
  FaDownload,
  isEmpty,
  groupBy,
  toTileCase,
  FaTruckMoving,
  FaShip,
  FaPlane,
  FaSubway,
  dMmm
} from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'
import { tripTabsBackground, modeBackground } from '@fareye/configs'

import { getTableColumns } from './Column'
import { formatDateTimeForCSV } from '../../../utility/function'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: modeBackground,
    width: 'fit-content',
    marginBottom: '8px'
  }
}

const modeIcons: any = {
  road: FaTruckMoving,
  ocean: FaShip,
  rail: FaSubway,
  air: FaPlane
}

export const TransporterDetails = ({ data, config }: any) => {
  const {
    config: { transporterColumns, type, links = {} }
  } = config
  const tableData = type === 'package' ? data.packageLegs : [data]
  const [searchInput, setSearchInput] = React.useState('')
  const debouncedSearchTerm = useDebounce(searchInput, 400)
  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const [filteredData, setFilteredData] = React.useState([])

  const displayDataFlag = !isEmpty(tableData)

  const { t } = useTranslation()
  React.useEffect(() => {
    setFilteredData(
      isEmpty(searchInput)
        ? tableData
        : tableData.filter((item: any) =>
            Object.values(item).includes(searchInput)
          )
    )
  }, [debouncedSearchTerm])

  const groupedData: any = !isEmpty(filteredData)
    ? groupBy(filteredData, 'transportMode')
    : []
  let translatedGroupedData = { ...groupedData }
  if (translatedGroupedData.ocean) {
    translatedGroupedData.ocean = translatedGroupedData.ocean.map(
      (item: any) => {
        return {
          ...item,
          inState: t(item.inState),
          status: t(item.status)
        }
      }
    )
  }
  let translatedTransporterColumns = { ...transporterColumns }
  if (translatedTransporterColumns.air) {
    translatedTransporterColumns.air = translatedTransporterColumns.air.map(
      (item: any) => {
        return {
          ...item,
          label: t(item.label)
        }
      }
    )
  }
  if (translatedTransporterColumns.ocean) {
    translatedTransporterColumns.ocean = translatedTransporterColumns.ocean.map(
      (item: any) => {
        return {
          ...item,
          label: t(item.label)
        }
      }
    )
  }
  if (translatedTransporterColumns.rail) {
    translatedTransporterColumns.rail = translatedTransporterColumns.rail.map(
      (item: any) => {
        return {
          ...item,
          label: t(item.label)
        }
      }
    )
  }
  if (translatedTransporterColumns.road) {
    translatedTransporterColumns.road = translatedTransporterColumns.road.map(
      (item: any) => {
        return {
          ...item,
          label: t(item.label)
        }
      }
    )
  }
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Label style={{ fontSize: '16px', fontWeight: 600 }}>
          {t('Transporter Details')}
        </Label>
        {displayDataFlag && (
          <Flex justifyContentSpaceBetween>
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchInput(e.target.value)
              }
              placeholder={t('Search Transporter')}
              style={{
                margin: '15px 0px 4px',

                fontSize: 12,
                lineHeight: 1,
                background: '#fff',
                borderColor: 'hsl(0,0%,80%)',
                color: 'rgba(151,151,151,1)'
              }}
            />
            <Button
              disabled={false}
              isLoading={false}
              variant="s primary"
              style={{ height: '30px', margin: '15px 0px 4px' }}
              onClick={() => {
                setDownloadLoading(true)
                downloadToCSV({
                  data: formatDateTimeForCSV(
                    translatedGroupedData,
                    translatedTransporterColumns
                  ),
                  options: { header: false },
                  fileName: `transporterDetail_${dMmm()}`
                })
                setDownloadLoading(false)
              }}
            >
              {t('Download CSV')}
              <FaDownload style={style.downloadIcon} />
            </Button>
          </Flex>
        )}
      </Flex>
      {!isEmpty(filteredData) ? (
        Object.keys(groupedData).map((key: string) => {
          const FaComponent = modeIcons[key]
            ? modeIcons[key]
            : modeIcons['road']
          return (
            <Flex style={style.tripTabs} column key={key}>
              <Label style={style.mode}>
                <FaComponent style={{ marginRight: '4px' }} />
                {t(toTileCase(key))}
              </Label>
              <Table
                className="striped responsive"
                totalElements={groupedData[key].length}
                sortable={false}
                showTotalCount={false}
                showPagination={false}
                data={groupedData[key]}
                columns={getTableColumns(
                  transporterColumns[key]
                    ? transporterColumns[key]
                    : transporterColumns['road'],
                  { t, links }
                )}
              />
            </Flex>
          )
        })
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
